import { render, staticRenderFns } from "./formgroup.vue?vue&type=template&id=2e34d69f"
import script from "./formgroup.js?vue&type=script&lang=js&external"
export * from "./formgroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports